import { render, staticRenderFns } from "./PropostaAssinantePapelItem.vue?vue&type=template&id=6381ec26"
import script from "./PropostaAssinantePapelItem.vue?vue&type=script&lang=js"
export * from "./PropostaAssinantePapelItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports